import React from 'react';
import { Search, Shield, LayoutTemplate } from 'lucide-react';
import { motion } from 'framer-motion';
export const ValueProp = () => {
  const blocks = [{
    icon: <Search className="w-8 h-8 text-brand-gold" data-id="element-162" />,
    title: 'MÁS CLARIDAD DESDE EL INICIO',
    desc: 'Sabés qué evaluar, qué preguntar, qué observar y cómo ordenar la información clínica del caso sin reducir el abordaje a comida, peso o cuerpo.'
  }, {
    icon: <Shield className="w-8 h-8 text-brand-gold" data-id="element-163" />,
    title: 'MÁS SEGURIDAD PROFESIONAL',
    desc: 'Tenés protocolos para evaluación, riesgo, ambivalencia, intervención, familia, recaídas y coordinación interdisciplinaria.'
  }, {
    icon: <LayoutTemplate className="w-8 h-8 text-brand-gold" data-id="element-164" />,
    title: 'MÁS ESTRUCTURA EN CADA ETAPA',
    desc: 'No es teoría abstracta. Son guías, plantillas, preguntas y recursos prácticos para aplicar en el trabajo clínico real con pacientes con TCA.'
  }];
  return <section className="py-20 px-4 bg-brand-cream text-brand-teal-dark" data-id="element-165">
      <div className="max-w-5xl mx-auto" data-id="element-166">
        <div className="text-center mb-16" data-id="element-167">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-168">
            UN SISTEMA PARA TRABAJAR TCA CON MÁS ORDEN CLÍNICO
          </h2>
          <div className="inline-block bg-brand-teal text-white px-6 py-2 rounded-full font-semibold text-sm" data-id="element-169">
            KIT Psicología en TCA™ | Sistema completo de intervención en 8
            etapas
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-170">
          {blocks.map((block, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-cream-dark hover:shadow-md transition-shadow" data-id="element-171">
              <div className="bg-brand-cream w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-172">
                {block.icon}
              </div>
              <h3 className="font-bold text-xl mb-4 font-serif" data-id="element-173">
                {block.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-174">{block.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};